
import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
interface AttributionData {
  source_title?: string;
  source_author?: string;
  source_url?: string;
  source_publication?: string;
  license_type?: string;
  copyright_notice?: string;
  permission_granted?: boolean;
}
interface AttributionFieldsProps {
  value: AttributionData;
  onChange: (val: AttributionData) => void;
}
const AttributionFields: React.FC<AttributionFieldsProps> = ({ value, onChange }) => (
  <div className="grid gap-4">
    <div>
      <Label htmlFor="source_title">Source Title</Label>
      <Input
        id="source_title"
        value={value.source_title || ""}
        onChange={e => onChange({ ...value, source_title: e.target.value })}
        placeholder="Book, site, or article title"
      />
    </div>
    <div>
      <Label htmlFor="source_author">Source Author</Label>
      <Input
        id="source_author"
        value={value.source_author || ""}
        onChange={e => onChange({ ...value, source_author: e.target.value })}
        placeholder="e.g. Jane Doe"
      />
    </div>
    <div>
      <Label htmlFor="source_url">Source URL</Label>
      <Input
        id="source_url"
        value={value.source_url || ""}
        onChange={e => onChange({ ...value, source_url: e.target.value })}
        placeholder="https://source.com"
      />
    </div>
    <div>
      <Label htmlFor="license_type">License Type</Label>
      <Input
        id="license_type"
        value={value.license_type || ""}
        onChange={e => onChange({ ...value, license_type: e.target.value })}
        placeholder="e.g. CC BY-SA 4.0"
      />
    </div>
    <div>
      <Label htmlFor="copyright_notice">Copyright Notice</Label>
      <Textarea
        id="copyright_notice"
        value={value.copyright_notice || ""}
        onChange={e => onChange({ ...value, copyright_notice: e.target.value })}
        placeholder="Copyright statement or attribution text"
        rows={2}
      />
    </div>
    <div className="flex items-center gap-2">
      <Checkbox
        id="permission_granted"
        checked={!!value.permission_granted}
        onCheckedChange={checked => onChange({ ...value, permission_granted: !!checked })}
      />
      <Label htmlFor="permission_granted">Permission granted for use</Label>
    </div>
  </div>
);
export type { AttributionData };
export default AttributionFields;
